import { render, staticRenderFns } from "./VideoRoomParticipant.vue?vue&type=template&id=4f20c8b4&scoped=true&"
import script from "./VideoRoomParticipant.vue?vue&type=script&lang=js&"
export * from "./VideoRoomParticipant.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomParticipant.vue?vue&type=style&index=0&id=4f20c8b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20c8b4",
  null
  
)

export default component.exports